import {VoyagerConfig} from './models/config';
import {data} from "vega-lite";

export const HISTORY_LIMIT = 20;

export const PLOT_HOVER_MIN_DURATION = 500;

/**
 * Types of draggable items (for react-dnd).
 */
export const DraggableType = {
  FIELD: 'field'
};

/**
 * Type of parent for Field Component
 */
export enum FieldParentType {
  ENCODING_SHELF,
  FIELD_LIST
};

export const SPINNER_COLOR = '#4C78A8';

export const DEFAULT_DATASETS = [
  {
    name: 'product',
    description: 'Product',
    url: '/api/voyager/table/product',
    id: '',
    group: 'predefined',
  },
  {
    name: 'product_group',
    description: 'Productgroup',
    url: '/api/voyager/table/product_group',
    id: '',
    group: 'predefined',
  },
  {
    name: 'components',
    description: 'Components',
    url: '/api/voyager/table/component',
    id: '',
    group: 'predefined',
  },
];


export const VOYAGER_CONFIG: VoyagerConfig = {
  showDataSourceSelector: true,
  serverUrl: process.env.SERVER
};



// WEBPACK FOOTER //
// ./src/constants.ts